import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { useSupplierStore } from "../../hooks/useSupplierStore";
import { SellerBranchesModal } from "./components/SellerBranchesModal";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'rut', label: 'Rut', align:'center' },
    { type: 'text', field: 'customer', label: 'Cliente', align:'center' },
    { type: 'text', field: 'nextvisit', label: 'Próxima visita', align:'center' },
    { type: 'text', field: 'visitmatter', label: 'Asunto de visita', align:'center' },
    { type: 'detail', field: 'detail', label: 'Detalle', align:'center' },
];

export const RoadMap = (props) => {

    const { sellerSelected } = props;

    const { setActionSupplier, getSuppliers, getSuppliersByCompany, deleteSupplier } = useSupplierStore();

    const [loading, setLoading] = useState(false);
    const [clients, setClients] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    useEffect(() => {
        getClientsApi()
    },[])

    const getClientsApi = async(search='') => {
        try {
            setLoading(true);
            const response = await getSuppliersByCompany(search);
            if(!response){
                setClients([]);
                setLoading(false);
                return false;
            }else{
                setClients(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onAdd = () => {
        setActionSupplier('add');
        setShowModal(true);
    }
    const onEdit = (rowSelected:any) => {
        setActionSupplier('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDelete = (rowSelected:any) => {
        setActionSupplier('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
    const onDetails = (rowSelected:any) => {
        setActionSupplier('detail');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDeleteConfirm = async() => {
        if (rowSelected) {
            setLoading(true);
            const response = await deleteSupplier(rowSelected.id)
            if(response){
                getClientsApi();
                setShowModalConfirm(false);
                setLoading(false);
                setRowSelected('');
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getClientsApi(term)}, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('');
    }

    return (
        <>
            <Grid item xs={12}>
                <CustomTable 
                    title={'Hoja de rutas del vendedor'}
                    columns={columns} 
                    loading={loading}
                    rows={clients || []}
                    onRowClick={() => {}}
                    hasOptions
                    onAddFn={onAdd}
                    onAddFnName={'Agregar'}
                    onDetails={onDetails}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    onSearch={onSearch}
                    dense
                />
            </Grid>
            {
                showModal && (
                    <SellerBranchesModal
                        open = {showModal}
                        closeModal = {() => {setShowModal(false)}}
                        clientSelected = {rowSelected}
                        listClients = {getClientsApi}
                        clearState = {clearState}
                        sellerSelected={sellerSelected}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={()=>{ setShowModalConfirm(false); clearState()}}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                    />
                )
            }
        </>
    )
}